import React from 'react';
import PropTypes from 'prop-types';
import './QuestionnaireNavigationButtons.scss';

function QuestionnaireNavigationButtons({
  activeStep,
  handleNextStep,
  handlePreviousStep,
  workflow,
  lastStep,
  position,
}) {
  return (
    <div className={`questionnaire-navigation-buttons ${position}`}>
      <div className="aside-1 mr-4">
        <button type="button" id={`${workflow}-${activeStep.replace(' ', '-')}-back`} className="btn btn-secondary-dark py-6 px-12" onClick={handlePreviousStep}>
          <i className="fa fa-chevron-left" />
        </button>
      </div>
      <div className="aside-2">
        {!lastStep
        && (
        <button type="button" id={`${workflow}-${activeStep.replace(' ', '-')}`} className="btn btn-primary-darkest" onClick={handleNextStep}>
          Next
          {' '}
          <i className="fa fa-chevron-right" />
        </button>
        )}
        {lastStep
        && (
        <button type="button" id={`${workflow}-${activeStep.replace(' ', '-')}`} className="btn btn-primary-darkest" onClick={handleNextStep}>
          Finish
          {' '}
          <i className="fa fa-chevron-right" />
        </button>
        )}
      </div>
    </div>
  );
}

QuestionnaireNavigationButtons.propTypes = {
  activeStep: PropTypes.string.isRequired,
  handleNextStep: PropTypes.func.isRequired,
  handlePreviousStep: PropTypes.func.isRequired,
  workflow: PropTypes.string.isRequired,
  lastStep: PropTypes.bool.isRequired,
  position: PropTypes.string,
};

QuestionnaireNavigationButtons.defaultProps = {
  position: '',
};

export default QuestionnaireNavigationButtons;
